import { ArtboardCornerPosition } from './types'

/**
 * Wraps canvas text based on a max width and returns an array of text lines.
 */
export const getWrappedCanvasText = (text: string, context: CanvasRenderingContext2D, maxWidth: number): string[] => {
    const words: string[] = text.split(' ')
    const lines: string[] = ['']
    let currentLineWidth = 0

    words.forEach((w, i) => {
        const word = w + (i === words.length - 1 ? '' : ' ')
        const { width } = context.measureText(word)
        if (currentLineWidth + width <= maxWidth) {
            currentLineWidth += width
            lines[lines.length - 1] += word
        } else {
            currentLineWidth = width
            lines.push(word)
        }
    })

    return lines
}

/**
 * Returns a canvas gradient.
 */
export const getCanvasTextFillStyle = (color: string, context: CanvasRenderingContext2D): CanvasGradient | string => {
    const colors = color.split(',')

    if (colors.length < 2) {
        return color
    }

    const gradient = context.createLinearGradient(0, context.canvas.height, context.canvas.width, 0)
    colors.forEach((color, i) => {
        gradient.addColorStop(i / (colors.length - 1), color)
    })

    return gradient
}

/**
 * Returns the opposite corner.
 */
export const getOppositeCorner = (corner: ArtboardCornerPosition): ArtboardCornerPosition => {
    switch (corner) {
        case ArtboardCornerPosition.TopLeft:
            return ArtboardCornerPosition.BottomRight
        case ArtboardCornerPosition.TopRight:
            return ArtboardCornerPosition.BottomLeft
        case ArtboardCornerPosition.BottomLeft:
            return ArtboardCornerPosition.TopRight
        case ArtboardCornerPosition.BottomRight:
            return ArtboardCornerPosition.TopLeft
    }
}
